/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductAssortmentPerformanceFilter
 */
export interface ProductAssortmentPerformanceFilter {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof ProductAssortmentPerformanceFilter
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof ProductAssortmentPerformanceFilter
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductAssortmentPerformanceFilter
     */
    selectedCentreIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductAssortmentPerformanceFilter
     */
    selectedDomainIds?: Array<string>;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterCustomerWholesaleEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    customerWholesale?: ProductAssortmentPerformanceFilterCustomerWholesaleEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentPerformanceFilter
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentPerformanceFilter
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductAssortmentPerformanceFilter
     */
    search?: string | null;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterGroupEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    group?: ProductAssortmentPerformanceFilterGroupEnum | null;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterOrderByEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    orderBy?: ProductAssortmentPerformanceFilterOrderByEnum | null;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterOrderDirectionEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    orderDirection?: ProductAssortmentPerformanceFilterOrderDirectionEnum;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterModeEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    mode?: ProductAssortmentPerformanceFilterModeEnum;
    /**
     * 
     * @type {ProductAssortmentPerformanceFilterSortByEnum}
     * @memberof ProductAssortmentPerformanceFilter
     */
    sortBy?: ProductAssortmentPerformanceFilterSortByEnum;
}


/**
 * @export
 */
export const ProductAssortmentPerformanceFilterCustomerWholesaleEnum = {
    Wholesale: 'wholesale',
    NonWholesale: 'non_wholesale',
    Unknown: 'unknown'
} as const;
export type ProductAssortmentPerformanceFilterCustomerWholesaleEnum = typeof ProductAssortmentPerformanceFilterCustomerWholesaleEnum[keyof typeof ProductAssortmentPerformanceFilterCustomerWholesaleEnum];

/**
 * @export
 */
export const ProductAssortmentPerformanceFilterGroupEnum = {
    A: 'A',
    B: 'B',
    C: 'C'
} as const;
export type ProductAssortmentPerformanceFilterGroupEnum = typeof ProductAssortmentPerformanceFilterGroupEnum[keyof typeof ProductAssortmentPerformanceFilterGroupEnum];

/**
 * @export
 */
export const ProductAssortmentPerformanceFilterOrderByEnum = {
    Product: 'product',
    Group: 'group',
    Share: 'share',
    CumulativeShare: 'cumulativeShare',
    Amount: 'amount',
    UnitPrice: 'unitPrice',
    Turnover: 'turnover'
} as const;
export type ProductAssortmentPerformanceFilterOrderByEnum = typeof ProductAssortmentPerformanceFilterOrderByEnum[keyof typeof ProductAssortmentPerformanceFilterOrderByEnum];

/**
 * @export
 */
export const ProductAssortmentPerformanceFilterOrderDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ProductAssortmentPerformanceFilterOrderDirectionEnum = typeof ProductAssortmentPerformanceFilterOrderDirectionEnum[keyof typeof ProductAssortmentPerformanceFilterOrderDirectionEnum];

/**
 * @export
 */
export const ProductAssortmentPerformanceFilterModeEnum = {
    Gross: 'gross',
    Net: 'net'
} as const;
export type ProductAssortmentPerformanceFilterModeEnum = typeof ProductAssortmentPerformanceFilterModeEnum[keyof typeof ProductAssortmentPerformanceFilterModeEnum];

/**
 * @export
 */
export const ProductAssortmentPerformanceFilterSortByEnum = {
    Turnover: 'turnover',
    Amount: 'amount'
} as const;
export type ProductAssortmentPerformanceFilterSortByEnum = typeof ProductAssortmentPerformanceFilterSortByEnum[keyof typeof ProductAssortmentPerformanceFilterSortByEnum];


/**
 * Check if a given object implements the ProductAssortmentPerformanceFilter interface.
 */
export function instanceOfProductAssortmentPerformanceFilter(value: object): value is ProductAssortmentPerformanceFilter {
    return true;
}

export function ProductAssortmentPerformanceFilterFromJSON(json: any): ProductAssortmentPerformanceFilter {
    return ProductAssortmentPerformanceFilterFromJSONTyped(json, false);
}

export function ProductAssortmentPerformanceFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAssortmentPerformanceFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'selectedCentreIds': json['selectedCentreIds'] == null ? undefined : json['selectedCentreIds'],
        'selectedDomainIds': json['selectedDomainIds'] == null ? undefined : json['selectedDomainIds'],
        'customerWholesale': json['customerWholesale'] === undefined ? undefined : json['customerWholesale'] === null ? null : json['customerWholesale'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
        'search': json['search'] === undefined ? undefined : json['search'] === null ? null : json['search'],
        'group': json['group'] === undefined ? undefined : json['group'] === null ? null : json['group'],
        'orderBy': json['orderBy'] === undefined ? undefined : json['orderBy'] === null ? null : json['orderBy'],
        'orderDirection': json['orderDirection'] == null ? undefined : json['orderDirection'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
    };
}

export function ProductAssortmentPerformanceFilterToJSON(json: any): ProductAssortmentPerformanceFilter {
    return ProductAssortmentPerformanceFilterToJSONTyped(json, false);
}

export function ProductAssortmentPerformanceFilterToJSONTyped(value?: ProductAssortmentPerformanceFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'selectedCentreIds': value['selectedCentreIds'],
        'selectedDomainIds': value['selectedDomainIds'],
        'customerWholesale': value['customerWholesale'],
        'limit': value['limit'],
        'page': value['page'],
        'search': value['search'],
        'group': value['group'],
        'orderBy': value['orderBy'],
        'orderDirection': value['orderDirection'],
        'mode': value['mode'],
        'sortBy': value['sortBy'],
    };
}

